export class OrganizationCreateParams {
  name: string;
  accountId: string;
  logoImg?: string;
  portalUrl?: string;

  constructor(name: string, accountId: string, logoImg?: string, portalUrl?: string) {
    this.name = name;
    this.accountId = accountId;
    this.logoImg = logoImg;
    this.portalUrl = portalUrl;
  }
}

export class OrganizationSearchParams {
  query?: string;
  limit?: number;
  skip?: number;
  status?: string;
  subdomain?: string;

  constructor(queryParams: any = {}) {
    this.query = queryParams.q || queryParams.query;
    this.limit = queryParams.limit ? parseInt(queryParams.limit) : undefined;
    this.skip = queryParams.skip ? parseInt(queryParams.skip) : undefined;
    this.status = queryParams.status;
    this.subdomain = queryParams.subdomain;
  }
}
